/* eslint-disable no-unused-vars */
/* eslint-disable react/jsx-indent-props */
/* eslint-disable max-len */
/* eslint-disable react/jsx-props-no-spreading */
import { XMarkIcon } from '@heroicons/react/24/outline';
import {
  React, useContext, useEffect, useState, useCallback,
} from 'react';
import { useForm } from 'react-hook-form';
import { useHistory, useParams } from 'react-router-dom';
import { useProject } from '../../../config/ProjectContext';
import SelectedObjectsToDeployContext from '../../../config/SelectedAssetsContext';
import GraphqlService from '../../../service/graphqlService';
import PageBanner from '../../utils/PageBanner';
import LoadingOverlay from '../../DataDictionary/LoadingOverlay';
import GlobalDeploy from './GlobalDeploy';
import MachineDeploy from './MachineDeploy';
import RegexDeploy from './RegexDeploy';
import MarketDeploy from './MarketDeploy';
import NewDeployHeader from './NewDeployHeader';
import PrimaryButton from '../../utils/PrimaryButton';
import YesNoDialog from '../../utils/YesNoDialog';
import {
  CREATE_SERIAL_DEPLOY_PERMISSION,
  CREATE_MARKET_DEPLOY_PERMISSION,
  CREATE_REGEX_DEPLOY_PERMISSION,
  CREATE_GLOBAL_DEPLOY_PERMISSION,
  DEPLOY_TYPE_GLOBAL,
  DEPLOY_TYPE_REGEX,
  VALIDATION_REGEX_MANDATORY,
  VALIDATION_MAX_1_REGEX,
  VALIDATION_LENGTH_MAX_REGEX,
  DEPLOY_TYPE_MARKET,
  VALIDATION_MARKET_MANDATORY,
  DEPLOY_TYPE_SERIAL,
} from '../../../utils/constants';
import TabPanel, { a11yProps } from '../../TabPanel';
import Restricted from '../../../authorization/Restricted';
import usePermission from '../../../authorization/permissionHook';
import { useSnackbar } from '../../../providers/SnackbarContext';
import DeploymentResultPopup from '../../DeploymentResultPopup/DeploymentResultPopup';
import ErrorPopup from '../../ErrorPopup/ErrorPopup';
import useGetDevicesNotAllowed from '../../../hooks/useGetDevicesNotAllowed';
import useAnalytics from '../../../hooks/useAnalytics';




export default function NewDeploy() {
  const { source } = useParams(); // 'asset' or 'bundle'
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertHeader, setAlertHeader] = useState('');
  const [alertText, setAlertText] = useState('');
  //  state values
  const [submitting, setSubmitting] = useState(false);

  // PERMISSIONS___________________________
  const [, allowedSerialDeployment] = usePermission(CREATE_SERIAL_DEPLOY_PERMISSION);
  const [, allowedMarketDeployment] = usePermission(CREATE_MARKET_DEPLOY_PERMISSION);
  const [, allowedRegexDeployment] = usePermission(CREATE_REGEX_DEPLOY_PERMISSION);
  const [, allowedGlobalDeployment] = usePermission(CREATE_GLOBAL_DEPLOY_PERMISSION);

  const [targets, setTargets] = useState([]);
  const [type, setType] = useState();
  const [myFiles, setMyFiles] = useState([]);
  const [regex, setRegex] = useState([]);
  const [market, setMarket] = useState('');
  const [selectedMarkets, setSelectedMarkets] = useState([]);

  const [valueTab, setValueTab] = useState(0);
  const [valuesMachineDeploy, setValuesMachineDeploy] = useState('');
  const [valuesRegexDeploy, setValuesRegexDeploy] = useState('');
  const [valuesMarketDeploy, setValuesMarketDeploy] = useState('');
  const [valuesGlobalDeploy, setValuesGlobalDeploy] = useState('');
  const [selectedExcludedValue, setSelectedExcludedValue] = useState(null);
  const [excludedValues, setExcludedValues] = useState(null);
  const [hasTriedSubmit, setHasTriedSubmit] = useState(false);

  // Staged deployment states
  const [stagedDeploymentDevice, setStagedDeploymentDevice] = useState(false);
  const [stagedDeploymentRegex, setStagedDeploymentRegex] = useState(false);
  const [stagedDeploymentMarket, setStagedDeploymentMarket] = useState(false);
  const [stagedDeploymentGlobal, setStagedDeploymentGlobal] = useState(false);

  // Staged deployment configuration states
  const [stagedConfigDevice, setStagedConfigDevice] = useState({ isValid: false });
  const [stagedConfigRegex, setStagedConfigRegex] = useState({ isValid: false });
  const [stagedConfigMarket, setStagedConfigMarket] = useState({ isValid: false });
  const [stagedConfigGlobal, setStagedConfigGlobal] = useState({ isValid: false });

  // NEW: Track loading state for full-screen overlay
  const [isCalculatingCandidates, setIsCalculatingCandidates] = useState(false);

  const [yesNoDialogOpen, setYesNoDialogOpen] = useState(false);
  const [yesNoDialogText, setYesNoDialogText] = useState('');
  const { selectedObjectsToDeploy } = useContext(SelectedObjectsToDeployContext);

  const [popupOpen, setPopupOpen] = useState(false);
  const [deployResultData, setDeployResultData] = useState({});

  const { setAnalytics } = useAnalytics();

  const { areAllowed: devicesNotAllowed } = useGetDevicesNotAllowed(targets);

  const history = useHistory();

  const openSnackBar = useSnackbar();

  const { project } = useProject();

  // useEffect hooks to manage staged deployment state based on conditions
  useEffect(() => {
    // For device deployment: disable if no devices/targets
    if (!targets || targets.length === 0) {
      setStagedDeploymentDevice(false);
    }
  }, [targets]);

  useEffect(() => {
    // For regex deployment: disable if no regex pattern
    if (!regex || regex.length === 0) {
      setStagedDeploymentRegex(false);
    }
  }, [regex]);

  useEffect(() => {
    // For market deployment: disable if no markets selected
    if (!selectedMarkets || selectedMarkets.length === 0) {
      setStagedDeploymentMarket(false);
    }
  }, [selectedMarkets]);

  // Global deployment is always enabled (no conditions required)

  // Staged deployment configuration handlers
  const handleStagedConfigChangeDevice = useCallback((config) => {
    setStagedConfigDevice(config || { isValid: false });
  }, []);

  const handleStagedConfigChangeRegex = useCallback((config) => {
    setStagedConfigRegex(config || { isValid: false });
  }, []);

  const handleStagedConfigChangeMarket = useCallback((config) => {
    setStagedConfigMarket(config || { isValid: false });
  }, []);

  const handleStagedConfigChangeGlobal = useCallback((config) => {
    setStagedConfigGlobal(config || { isValid: false });
  }, []);

  // NEW: Loading change handlers for full-screen overlay
  const handleLoadingChangeDevice = useCallback((isLoading) => {
    setIsCalculatingCandidates(isLoading);
  }, []);

  const handleLoadingChangeRegex = useCallback((isLoading) => {
    setIsCalculatingCandidates(isLoading);
  }, []);

  const handleLoadingChangeMarket = useCallback((isLoading) => {
    setIsCalculatingCandidates(isLoading);
  }, []);

  const handleLoadingChangeGlobal = useCallback((isLoading) => {
    setIsCalculatingCandidates(isLoading);
  }, []);

  // Clear staged config when targets are removed for smooth transitions
  useEffect(() => {
    if (targets.length === 0) {
      setStagedConfigDevice({ isValid: false, hasInput: false });
    }
  }, [targets]);

  useEffect(() => {
    if (!regex || regex.length === 0) {
      setStagedConfigRegex({ isValid: false, hasInput: false });
    }
  }, [regex]);

  useEffect(() => {
    if (selectedMarkets.length === 0) {
      setStagedConfigMarket({ isValid: false, hasInput: false });
    }
  }, [selectedMarkets]);

  function openErrorPopup(header, text) {
    setAlertHeader(header);
    setAlertText(text);
    setAlertOpen(true);
  }

  // DATA RETRIEVAL __________________________

  // FORM_________________________________
  const {
    handleSubmit, formState: { errors },
  } = useForm();

  function validRegexDeployment(targetsOption) {
    if (!hasTriedSubmit) return true;
    if (targetsOption.length === 0) {
      openErrorPopup('Incomplete form', VALIDATION_REGEX_MANDATORY);
      return false;
    }
    if (targetsOption.length > 1) {
      openErrorPopup('Incomplete form', VALIDATION_MAX_1_REGEX);
      return false;
    }
    if (targetsOption[0].length > 300) {
      openErrorPopup('Incomplete form', VALIDATION_LENGTH_MAX_REGEX);
      return false;
    }
    return true;
  }

  function validMarketDeployment(targetsOption) {
    if (!hasTriedSubmit) return true;
    if (targetsOption.length === 0) {
      openErrorPopup('Incomplete form', VALIDATION_MARKET_MANDATORY);
      return false;
    }
    return true;
  }

  function buildGlobalDeployParams(excludedValue, excludedValues) {
    return {
      target: '*', // Target always sent as "*" string for global deployment
      targetMarket: excludedValue === 'EXCLUDE-MARKET' ? '*' : undefined, // Specific target market
      exclude: excludedValue === 'EXCLUDE-SERIAL' && excludedValues ? excludedValues : undefined, // Serial exclusions
      excludeMarket: excludedValue === 'EXCLUDE-MARKET' && excludedValues ? excludedValues : undefined, // Market exclusions
    };
  }

  function getCanaryStageConfig(stagedDeploymentEnabled, stagedConfig) {
    if (!stagedDeploymentEnabled || !stagedConfig.isValid) {
      return null;
    }

    if (stagedConfig.targetType === 'absolute') {
      return {
        Absolute: stagedConfig.value,
      };
    } else {
      return {
        Relative: stagedConfig.value,
      };
    }
  }

  async function deployGlobalType(iProject, comments, typeDeploy, targetsDeploy) {
    try {
      const isBundle = selectedObjectsToDeploy?.length > 0 && selectedObjectsToDeploy[0].type === 'bundle';
      const releaseID = selectedObjectsToDeploy?.length > 0 ? selectedObjectsToDeploy[0].releaseID : null;
      
      // When deploying from a bundle, don't send fileIds - only send releaseID
      // The backend will retrieve the files from the bundle
      const fileIds = isBundle ? [] : selectedObjectsToDeploy.map((asset) => asset.fileID).filter((fileId) => fileId != null);
      
      const canaryStage = getCanaryStageConfig(stagedDeploymentGlobal, stagedConfigGlobal);
      
      // Build parameters with the correct format
      const deployParams = buildGlobalDeployParams(selectedExcludedValue, excludedValues);

      const creationResponse = await GraphqlService.createGlobalDeploy(
        iProject.code,
        fileIds,
        releaseID,
        typeDeploy,
        deployParams.value, // Main targets array ["*"]
        comments,
        deployParams.target, // Specific target ("*" or undefined)
        deployParams.targetMarket, // Specific target market ("*" or undefined)
        deployParams.exclude, // Serial exclusions array or undefined
        deployParams.excludeMarket, // Market exclusions array or undefined
        canaryStage,
      );

      setDeployResultData({
        deployID: creationResponse.deployID,
        waveId: creationResponse.waveId,
        deployIDS: creationResponse.deployIDS,
        newDeployIDs: creationResponse.newDeployIDs,
        alreadyExistingDeployIDs: creationResponse.alreadyExistingDeployIDs,
      });
      setPopupOpen(true);
    } catch (err) {
      let errorMsg = err;
      if (typeof errorMsg !== 'string') {
        if (errorMsg instanceof Error && errorMsg.message) {
          errorMsg = errorMsg.message;
        } else {
          errorMsg = JSON.stringify(errorMsg);
        }
      }
      openSnackBar(errorMsg, 'error');
    }
  }

  async function deployRegexType(iProject, comments, typeDeploy, targetsDeploy) {
    const isBundle = selectedObjectsToDeploy?.length > 0 && selectedObjectsToDeploy[0].type === 'bundle';
    const releaseID = selectedObjectsToDeploy?.length > 0 ? selectedObjectsToDeploy[0].releaseID : null;
    
    // When deploying from a bundle, don't send fileIds - only send releaseID
    const fileIds = isBundle ? [] : selectedObjectsToDeploy.map((asset) => asset.fileID).filter((fileId) => fileId !== null);
    
    if (validRegexDeployment(targetsDeploy)) {
      try {
        const canaryStage = getCanaryStageConfig(stagedDeploymentRegex, stagedConfigRegex);
        const creationResponse = await GraphqlService.createRegexDeploy(iProject.code, fileIds, releaseID, typeDeploy, targetsDeploy, comments, undefined, canaryStage);
        setDeployResultData({
          deployID: creationResponse.deployID,
          waveId: creationResponse.waveId,
          deployIDS: creationResponse.deployIDS,
          newDeployIDs: creationResponse.newDeployIDs,
          alreadyExistingDeployIDs: creationResponse.alreadyExistingDeployIDs,
        });
        setPopupOpen(true);
      } catch (err) {
        openSnackBar(`Error  deploying: ${err?.toString()}`, 'error');
      }
    }
  }

  async function deployMarketType(iProject, comments, typeDeploy, targetsDeploy) {
    const isBundle = selectedObjectsToDeploy?.length > 0 && selectedObjectsToDeploy[0].type === 'bundle';
    const releaseID = selectedObjectsToDeploy?.length > 0 ? selectedObjectsToDeploy[0].releaseID : null;
    
    // When deploying from a bundle, don't send fileIds - only send releaseID
    const fileIds = isBundle ? [] : selectedObjectsToDeploy.map((asset) => asset.fileID).filter((fileId) => fileId != null);
    
    if (validMarketDeployment(targetsDeploy)) {
      try {
        const canaryStage = getCanaryStageConfig(stagedDeploymentMarket, stagedConfigMarket);
        const creationResponse = await GraphqlService.createMarketDeploy(iProject.code, fileIds, releaseID, typeDeploy, targetsDeploy, comments, undefined, canaryStage);
        setDeployResultData({
          deployID: creationResponse.deployID,
          waveId: creationResponse.waveId,
          deployIDS: creationResponse.deployIDS,
          newDeployIDs: creationResponse.newDeployIDs,
          alreadyExistingDeployIDs: creationResponse.alreadyExistingDeployIDs,
        });
        setPopupOpen(true);
      } catch (err) {
        openSnackBar(`Error  deploying: ${err?.toString()}`, 'error');
      }
    }
  }

  useEffect(() => {
    setPopupOpen(
      (deployResultData.deployID != null || (deployResultData.deployIDS != null && deployResultData.deployIDS.length > 0) || deployResultData.waveId != null),
    );
  }, [deployResultData]);

  async function deviceDeployment(iProject, comments, typeDeploy, targetsDeploy) {
    const isBundle = selectedObjectsToDeploy?.length > 0 && selectedObjectsToDeploy[0].type === 'bundle';
    const releaseID = selectedObjectsToDeploy?.length > 0 ? selectedObjectsToDeploy[0].releaseID : null;
    
    // When deploying from a bundle, don't send fileIds - only send releaseID
    const fileIds = isBundle ? [] : selectedObjectsToDeploy.map((asset) => asset.fileID).filter((fileId) => fileId != null);
    
    try {
      const canaryStage = getCanaryStageConfig(stagedDeploymentDevice, stagedConfigDevice);
      const creationResponse = await GraphqlService.createSerialDeploy(iProject.code, fileIds, releaseID, typeDeploy, targetsDeploy, comments, undefined, canaryStage);
      setDeployResultData({
        deployID: creationResponse.deployID,
        waveId: creationResponse.waveId,
        deployIDS: creationResponse.deployIDS,
        newDeployIDs: creationResponse.newDeployIDs,
        alreadyExistingDeployIDs: creationResponse.alreadyExistingDeployIDs,
      });
    } catch (err) {
      openSnackBar(`Error  deploying: ${err?.toString()}`, 'error');
    }
  }

  async function save(iProject, comments, typeDeploy, targetsDeploy) {
    try {
      setSubmitting(true);
      if (typeDeploy === '') {
        openErrorPopup('Incomplete form', 'You must choose a target to be deployed');
      } else if (typeDeploy === DEPLOY_TYPE_GLOBAL) {
        deployGlobalType(iProject, comments, typeDeploy, null); // Target is built internally
      } else if (typeDeploy === DEPLOY_TYPE_REGEX) {
        deployRegexType(iProject, comments, typeDeploy, targetsDeploy);
      } else if (typeDeploy === DEPLOY_TYPE_MARKET) {
        deployMarketType(iProject, comments, typeDeploy, targetsDeploy);
      } else if (typeDeploy === DEPLOY_TYPE_SERIAL) {
        if (devicesNotAllowed?.length > 0) {
          throw new Error(`The following devices are not allowed: ${devicesNotAllowed.join(', ')}`);
        }
        deviceDeployment(iProject, comments, typeDeploy, targetsDeploy);
      }
    } catch (error) {
      openErrorPopup('Error', `ERROR - deployment failed. ${error.message}`);
    }
    setSubmitting(false);
  }

  function checkDisableStatus() {
    switch (valueTab) {
      case 0:
        // Device deployment
        if (targets.length === 0) return true;
        return stagedDeploymentDevice && !stagedConfigDevice.isValid;
      case 1:
        // Regex deployment
        if (regex.length === 0) return true;
        return stagedDeploymentRegex && !stagedConfigRegex.isValid;
      case 2:
        // Market deployment
        if (selectedMarkets.length === 0) return true;
        return stagedDeploymentMarket && !stagedConfigMarket.isValid;
      default:
        // Global deployment
        return stagedDeploymentGlobal && !stagedConfigGlobal.isValid;
    }
  }

  const getValues = () => {
    switch (valueTab) {
      case 0:
        return valuesMachineDeploy;
      case 1:
        return valuesRegexDeploy;
      case 2:
        return valuesMarketDeploy;
      default:
        // global
        return valuesGlobalDeploy;
    }
  };

  const onSubmit = (data) => {
    setHasTriedSubmit(true);
    if (type === DEPLOY_TYPE_GLOBAL) {
      setYesNoDialogText('Are you sure you want to launch a global deploy?');
      setYesNoDialogOpen(true);
      return;
    }
    save(project, getValues(), type, targets);
  };

  const handleClose = () => {
    setPopupOpen(false);
    history.push('/waves');
  };

  // WEBPAGE______________________________
  const handleChange = (event, newValue) => {
    setHasTriedSubmit(false);
    
    // NEW: Reset all staged deployment states when switching tabs
    // This prevents stale configuration and concurrent API calls
    setStagedDeploymentDevice(false);
    setStagedDeploymentRegex(false);
    setStagedDeploymentMarket(false);
    setStagedDeploymentGlobal(false);
    
    // Reset staged configs
    setStagedConfigDevice({ isValid: false });
    setStagedConfigRegex({ isValid: false });
    setStagedConfigMarket({ isValid: false });
    setStagedConfigGlobal({ isValid: false });
    
    // Clear loading state
    setIsCalculatingCandidates(false);
    
    let analyticsName = '';
    switch (newValue) {
      case 0:
        analyticsName = 'asset_management-create_deployment-device_deployment';
        break;
      case 1:
        analyticsName = 'asset_management-create_deployment-regex_deployment';
        break;
      case 2:
        analyticsName = 'asset_management-create_deployment-market_deployment';
        break;
      case 3:
        analyticsName = 'asset_management-create_deployment-global_deployment';
        break;
      default:
        analyticsName = '';
    }

    if (analyticsName) {
      setAnalytics({
        event: 'button_clicked',
        extraParams: { name: analyticsName }
      });
    }
    setValueTab(newValue);
  };



  const renderMyFiles = () => {
    if (myFiles.length > 0 && targets.length > 0) {
      return (
        <div className="flex items-center p-6">
          <div className="inline-flex items-center bg-white text-gray-700 border border-blue-500 rounded-full px-3 py-1 text-sm">
            {myFiles[0].name}
            <button
              onClick={() => setMyFiles('')}
              className="ml-2 text-gray-500 hover:text-gray-700"
              id="chipNewDeploymentFile"
            >
              <XMarkIcon className="w-4 h-4" />
            </button>
          </div>
          <div className="pl-2 text-gray-600 text-sm italic">
            {targets.length}
            &nbsp;serial numbers uploaded
          </div>
        </div>
      );
    }
    return ' ';
  };

  return (
    <div className="bg-gray-50 min-h-screen w-full max-w-full overflow-x-hidden">
      {/* Full-screen loading overlay for blocking UI during candidate calculation */}
      <LoadingOverlay 
        isLoading={isCalculatingCandidates} 
        title="Calculating Candidates"
        message="Please wait while we calculate the deployment candidates..."
      />
      <YesNoDialog
        open={yesNoDialogOpen}
        setOpen={setYesNoDialogOpen}
        header="Global deployment"
        body={typeof yesNoDialogText === 'string' ? yesNoDialogText : (yesNoDialogText?.message || JSON.stringify(yesNoDialogText))}
        action={() => save(project, getValues(), type, targets)}
        actionName="Deploy"
      />
      <DeploymentResultPopup
        open={popupOpen}
        onClose={handleClose} // Close the popup when needed
        deployResultData={deployResultData}
      />
      <ErrorPopup
        open={alertOpen}
        onClose={() => setAlertOpen(false)}
        title={alertHeader}
        description={alertText}
      />
      <PageBanner title="CREATE DEPLOYMENT" />
      <form onSubmit={(e) => e.preventDefault()} className="bg-gray-50 w-full max-w-full">
        <NewDeployHeader objectsToDeploy={selectedObjectsToDeploy} />

        <div className="flex flex-col items-center max-w-full">
          <div className="w-full max-w-full">
            <div className="bg-white shadow-sm overflow-x-auto">
              <div className="flex border-b border-gray-200 justify-center min-w-fit">
                <button
                  id="tabMachineDeployment"
                  onClick={(e) => handleChange(e, 0)}
                  disabled={!allowedSerialDeployment}
                  className={`px-2 sm:px-6 py-3 text-center font-bold text-xs sm:text-sm whitespace-nowrap ${
                    valueTab === 0 
                      ? 'text-blue-600 border-b-4 border-blue-600' 
                      : 'text-gray-500 hover:text-gray-700'
                  } ${!allowedSerialDeployment ? 'opacity-50 cursor-not-allowed' : ''}`}
                >
                  <span className="hidden sm:inline">DEVICE DEPLOYMENT</span>
                  <span className="sm:hidden">DEVICE</span>
                </button>
                <button
                  id="tabRegexDeployment"
                  onClick={(e) => handleChange(e, 1)}
                  disabled={!allowedRegexDeployment}
                  className={`px-2 sm:px-6 py-3 text-center font-bold text-xs sm:text-sm whitespace-nowrap ${
                    valueTab === 1 
                      ? 'text-blue-600 border-b-4 border-blue-600' 
                      : 'text-gray-500 hover:text-gray-700'
                  } ${!allowedRegexDeployment ? 'opacity-50 cursor-not-allowed' : ''}`}
                >
                  <span className="hidden sm:inline">REGEX DEPLOYMENT</span>
                  <span className="sm:hidden">REGEX</span>
                </button>
                <button
                  id="tabMarketDeployment"
                  onClick={(e) => handleChange(e, 2)}
                  disabled={!allowedMarketDeployment}
                  className={`px-2 sm:px-6 py-3 text-center font-bold text-xs sm:text-sm whitespace-nowrap ${
                    valueTab === 2 
                      ? 'text-blue-600 border-b-4 border-blue-600' 
                      : 'text-gray-500 hover:text-gray-700'
                  } ${!allowedMarketDeployment ? 'opacity-50 cursor-not-allowed' : ''}`}
                >
                  <span className="hidden sm:inline">MARKET DEPLOYMENT</span>
                  <span className="sm:hidden">MARKET</span>
                </button>
                <button
                  id="tabGlobalDeployment"
                  onClick={(e) => handleChange(e, 3)}
                  disabled={!allowedGlobalDeployment}
                  className={`px-2 sm:px-6 py-3 text-center font-bold text-xs sm:text-sm whitespace-nowrap ${
                    valueTab === 3 
                      ? 'text-blue-600 border-b-4 border-blue-600' 
                      : 'text-gray-500 hover:text-gray-700'
                  } ${!allowedGlobalDeployment ? 'opacity-50 cursor-not-allowed' : ''}`}
                >
                  <span className="hidden sm:inline">GLOBAL DEPLOYMENT</span>
                  <span className="sm:hidden">GLOBAL</span>
                </button>
              </div>
            </div>
            <Restricted to={[CREATE_SERIAL_DEPLOY_PERMISSION]}>
              <TabPanel value={valueTab} index={0} className="bg-gray-50">
                <MachineDeploy targets={targets} setTargets={setTargets} setType={setType} setMyFiles={setMyFiles} values={valuesMachineDeploy} setValues={setValuesMachineDeploy} renderMyFiles={renderMyFiles} stagedDeployment={stagedDeploymentDevice} setStagedDeployment={setStagedDeploymentDevice} onStagedConfigChange={handleStagedConfigChangeDevice} onLoadingChange={handleLoadingChangeDevice} />
              </TabPanel>
            </Restricted>
            <Restricted to={[CREATE_REGEX_DEPLOY_PERMISSION]}>
              <TabPanel value={valueTab} index={1} className="bg-gray-50">
                <RegexDeploy setTargets={setTargets} setType={setType} values={valuesRegexDeploy} setValues={setValuesRegexDeploy} regex={regex} setRegex={setRegex} stagedDeployment={stagedDeploymentRegex} setStagedDeployment={setStagedDeploymentRegex} onStagedConfigChange={handleStagedConfigChangeRegex} onLoadingChange={handleLoadingChangeRegex} />
              </TabPanel>
            </Restricted>
            <Restricted to={[CREATE_MARKET_DEPLOY_PERMISSION]}>
              <TabPanel value={valueTab} index={2} className="bg-gray-50">
                <MarketDeploy setTargets={setTargets} setType={setType} values={valuesMarketDeploy} setValues={setValuesMarketDeploy} market={market} setMarket={setMarket} selectedMarkets={selectedMarkets} setSelectedMarkets={setSelectedMarkets} stagedDeployment={stagedDeploymentMarket} setStagedDeployment={setStagedDeploymentMarket} onStagedConfigChange={handleStagedConfigChangeMarket} onLoadingChange={handleLoadingChangeMarket} />
              </TabPanel>
            </Restricted>
            <Restricted to={[CREATE_GLOBAL_DEPLOY_PERMISSION]}>
              <TabPanel value={valueTab} index={3} className="bg-gray-50">
                <GlobalDeploy
                  setType={setType}
                  project={project}
                  values={valuesGlobalDeploy}
                  setValues={setValuesGlobalDeploy}
                  selectedExcludedValue={selectedExcludedValue}
                  setSelectedExcludedValue={setSelectedExcludedValue}
                  excludedValues={excludedValues}
                  setExcludedValues={setExcludedValues}
                  stagedDeployment={stagedDeploymentGlobal}
                  setStagedDeployment={setStagedDeploymentGlobal}
                  onStagedConfigChange={handleStagedConfigChangeGlobal}
                  onLoadingChange={handleLoadingChangeGlobal}
                />
              </TabPanel>
            </Restricted>
          </div>
        </div>
        
        <div className="flex flex-col items-center bg-gray-50 w-full pb-16">
          <div className="flex flex-col sm:flex-row sm:flex-row-reverse mt-6 px-4 sm:px-6 gap-4 w-full max-w-full justify-center sm:justify-end">
            <div className="order-1 sm:order-2">
              <PrimaryButton
                type="button"
                variant="contained"
                color="primary"
                disabled={checkDisableStatus()}
                id="btnDeployment"
                onClick={() => {
                  setAnalytics({
                    event: 'button_clicked',
                    extraParams: { name: 'asset_management-create_deployment-deploy' }
                  });
                  onSubmit();
                }}
                className="w-full sm:w-auto"
              >
                Deploy
              </PrimaryButton>
            </div>
            <div className="order-2 sm:order-1">
              <button
                type="button"
                disabled={submitting}
                onClick={() => {
                  setAnalytics({
                    event: 'button_clicked',
                    extraParams: { name: 'asset_management-create_deployment-cancel' }
                  });
                  history.goBack();
                }}
                className="w-full sm:w-auto px-4 py-2 border border-gray-300 rounded-xl text-gray-700 bg-white hover:bg-gray-50 disabled:opacity-50"
                id="btnCancelDeployment"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
}
